export default __webpack_public_path__ + "static/media/Transfer_certificate_1.aec737a6.svg";